export class User {
    getUser() {
        return window.localStorage.getItem('name');
    }

    getBirthdate() {
        return window.localStorage.getItem('birthdate');
    }

    setUser(name, email, token, birthdate) {
        window.localStorage.setItem('name', name);
        window.localStorage.setItem('email', email);
        window.localStorage.setItem('birthdate', birthdate);
        window.localStorage.setItem('token', token);
    }

    logout() {
        window.localStorage.removeItem('name');
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('birthdate');
        window.localStorage.removeItem('token');
        location.reload();
    }
}

export function isAuthenticated() {
    const token = window.localStorage.getItem('token');
    if(token) {
        return true;
    }
    return false;
}


// WEBPACK FOOTER //
// ./src/models/User.js